function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "note_icn");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-238.000000, -21.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "note_icn",
  transform: "translate(238.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "note_icn-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "note_icn"
}, /*#__PURE__*/React.createElement("g", {
  id: "paper",
  transform: "translate(0.161086, 0.302733)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-1",
  points: "19.2099332 0.75 19.209 14.656 23.3984342 10.1317161 25.3515156 12.0456505 18.948 18.73 18.9487983 23.8725108 6.57978171 23.8725108 6.57978171 23.3725108 18.448 23.372 18.448 19.1917671 18.1739466 19.485104 17.8389142 19.1917671 24.648 12.056 23.416 10.848 17.4980588 17.2402732 16.6866085 18.1167626 16.3846731 17.7178731 18.709 15.182 18.709 1.249 1.249 1.249 1.25 17.9469146 0.75 17.9469146 0.75 0.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66109015,17.6027753 L1,17.6027753 C0.778417609,17.6027753 0.666364975,17.8696994 0.821551174,18.0278639 L6.48264132,23.7975994 C6.63943223,23.9573993 6.91109015,23.8463844 6.91109015,23.6225108 L6.91109015,17.8527753 C6.91109015,17.7147041 6.79916133,17.6027753 6.66109015,17.6027753 Z M6.411,18.102 L6.411,23.011 L1.595,18.102 L6.411,18.102 Z",
  id: "Stroke-3"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-8",
  points: "14.6106533 7.27730665 14.6106533 7.77730665 5.13891416 7.77730665 5.13891416 7.27730665"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-7",
  points: "14.6106533 10.6923264 14.6106533 11.1923264 5.08891416 11.1923264 5.08891416 10.6923264"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-6",
  points: "14.6106533 14.1073462 14.6106533 14.6073462 5.08891416 14.6073462 5.08891416 14.1073462"
})), /*#__PURE__*/React.createElement("g", {
  id: "pencil",
  transform: "translate(15.000000, 17.700000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.3350324,2.0878369 L1.54575895,0.320605936 L0.462595531,3.25976357 L3.3350324,2.0878369 Z M1.746,1.221 L2.444,1.911 L1.323,2.368 L1.746,1.221 Z",
  id: "Stroke-13"
})))))));

var SvgNoteIcn = function SvgNoteIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "25px",
    viewBox: "0 0 27 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoteIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note_icn.22a44875.svg";
export { ForwardRef as ReactComponent };